module.exports = __webpack_public_path__ + "media/images/front/icons/mypage-67b3dea7ff34057be38a07b272b53a5d.png";